import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ResultUseGochiDialog from '../molecules/ResultUseGochiDialog';

const styles = {
  button: {
    margin: '5px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(
  ({
    classes,
    openResult,
    updateOpenResult,
    onClickAction,
    name,
    resultData,
    disabled,
    closeAction,
    isFukuoka
  }) => {
    return (
      <>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onClickAction}
          disabled={disabled}
        >
          {name}
        </Button>
        <ResultUseGochiDialog
          openResult={openResult}
          updateOpenResult={updateOpenResult}
          closeAction={closeAction}
          target=""
          resultData={resultData}
          isFukuoka={isFukuoka}
        />
      </>
    );
  }
);

export default withStyles(styles)(button);
